import httpClient from "@/apis/base/axios-httpclient";
import BaseAPI from "./base/base-api";
import qs from "qs";

class ConfigAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "account";

  /**
   * Lấy context theo sid khi đăng nhập vào từ amis
   */
  getContext(param) {
    let queryString = qs.stringify(param);
    let request = {
      url: [this.getAPIUrl(), "/context?", queryString].join(""),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin phân quyền theo chi nhánh
   * Nếu không truyền thì sẽ đùng chi nhánh trong context
   */
  getPermission(orgId) {
    var url = [this.getAPIUrl(), "permission"];
    if (orgId) {
      url.push(orgId);
    }
    let request = {
      url: url.join("/"),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Đăng xuất khỏi ứng dụng
   */
  logoff() {
    let request = {
      url: [this.getAPIUrl(), "logoff"].join("/"),
    };

    return httpClient.postAsync(request);
  }
}

export default new ConfigAPI();
